import { Directive, forwardRef, HostListener } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appTrimValue]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrimValueAccessor),
      multi: true,
    },
  ],
})
export class TrimValueAccessor extends DefaultValueAccessor {
  @HostListener('input', ['$event.target.value'])
  public ngOnChange = (val: string) => {
    this.onChange(val.trim());
  };
  @HostListener('blur', ['$event.target.value'])
  public ngOnBlur = (val: string) => {
    this.writeValue(val.trim());
    this.onTouched();
  };
}
